import { userData, preData } from "./data";
import { cloneDeep } from 'lodash';
export var transferGetData = function transferGetData(resDate, props) {
  var language;

  if (props.initialData && props.initialData.staticSource && props.initialData.staticSource.supportedLanguages) {
    language = props.initialData.staticSource.supportedLanguages.filter(function (item) {
      return item.value === resDate.language;
    });
  }

  userData.languageRegion = {
    language: language && language[0] || props.initialData && props.initialData.staticSource.currentLanguage,
    timeZone: {
      Alpha2Code: resDate.timeZoneAlpha2Code,
      Alpha3Code: resDate.timeZoneAlpha3Code,
      DstOffset: resDate.timeZone
    },
    country: {
      geonameId: resDate.countryGeoNameId && Number(resDate.countryGeoNameId),
      countryName: resDate.country
    }
  };
  var userPhones = [];

  if (resDate.userPhones && resDate.userPhones.length) {
    resDate.userPhones.forEach(function (item, i) {
      userPhones.push({
        id: item.phoneId,
        _id: i,
        phoneType: {
          name: item.type && userData.staticSource.phoneTypeList.filter(function (i) {
            return i.value === item.type;
          })[0].name,
          value: item.type
        },
        phoneCountryCode: {
          Code: item.phone.countryCode || '',
          GeonameId: item.phone.countryCodeGeoNameId && Number(item.phone.countryCodeGeoNameId) || ''
        },
        geonameId: item.phone.countryCodeGeoNameId || '',
        customName: item.phone.name || '',
        phoneNumber: item.phone.number,
        extension: item.phone.extension || ''
      });
    });
    var mainNumber = userPhones.filter(function (item) {
      return item.id === resDate.mobilePhoneId;
    });

    if (mainNumber && mainNumber.length) {
      var filteredUserPhones = userPhones.filter(function (item) {
        return item.id !== resDate.mobilePhoneId;
      });
      mainNumber[0].main = true;
      filteredUserPhones.unshift(mainNumber[0]);
      userPhones = filteredUserPhones;
    }
  }

  userData.profileInfo = {
    company: resDate.organization.name,
    email: resDate.email,
    firstName: resDate.givenName,
    lastName: resDate.surname,
    phoneNumberList: userPhones
  };
  var addressList = [];

  if (resDate.userAddresses && resDate.userAddresses.length) {
    resDate.userAddresses.forEach(function (item, i) {
      addressList.push({
        id: item.adderessId,
        _id: i,
        addressName: item.address.name || '',
        address: item.address.line1 || '',
        addressLine2: item.address.line2 || '',
        city: item.address.city || '',
        province: {
          name: item.address.stateOrProvince || '',
          geonameId: item.address.stateOrProvinceGeoNameId && Number(item.address.stateOrProvinceGeoNameId)
        },
        country: {
          countryName: item.address.country || '',
          geonameId: item.address.countryGeoNameId && Number(item.address.countryGeoNameId),
          continent: item.address.region || ''
        },
        zipCode: item.address.zipOrPostcode || ''
      });
    });
  }

  userData.addressInfo = addressList;
  userData.mainAddress = {
    id: null,
    companyFacility: {
      id: "1",
      companyFacility: "companyFacility Btoatw."
    },
    addressName: "Main Facility",
    address: resDate.organization.primaryAddress.line1,
    addressLine2: resDate.organization.primaryAddress.line2,
    city: resDate.organization.primaryAddress.city,
    province: {
      geonameId: resDate.organization.primaryAddress.stateOrProvinceGeoNameId,
      name: resDate.organization.primaryAddress.stateOrProvince
    },
    zipCode: resDate.organization.primaryAddress.zipOrPostcode,
    country: {
      geonameId: resDate.organization.primaryAddress.countryGeoNameId,
      countryName: resDate.organization.primaryAddress.country
    },
    main: true
  };
  userData.userImg = resDate && resDate.avatar && resDate.avatar.url;
  preData.languageRegion = cloneDeep(userData.languageRegion);
  preData.profileInfo = cloneDeep(userData.profileInfo);
  preData.addressInfo = cloneDeep(userData.addressInfo);
};
export var transferPostData = function transferPostData() {
  var addressList = [];

  if (userData.addressInfo && userData.addressInfo.length) {
    userData.addressInfo.forEach(function (item) {
      addressList.push({
        id: item.id || null,
        name: item.addressName,
        line1: item.address,
        line2: item.addressLine2,
        zipOrPostcode: item.zipCode,
        city: item.city,
        country: item.country && item.country.countryName,
        countryGeoNameId: item.country && item.country.geonameId,
        stateOrProvince: item.province && item.province.name,
        stateOrProvinceGeoNameId: item.province && item.province.geonameId,
        region: item.country && item.country.continent || '',
        isMain: item.main ? item.main : false
      });
    });
  }

  var phoneList = [];

  if (userData.profileInfo && userData.profileInfo.phoneNumberList && userData.profileInfo.phoneNumberList.length) {
    userData.profileInfo.phoneNumberList.forEach(function (item) {
      phoneList.push({
        id: item.id || null,
        countryCode: item.phoneCountryCode.Code,
        countryCodeGeoNameId: item.phoneCountryCode.GeonameId,
        number: item.phoneNumber,
        extension: item.extension,
        customName: item.customName,
        type: item.phoneType && item.phoneType.value
      });
    });
  }

  var data = {
    country: userData.languageRegion.country && userData.languageRegion.country.countryName,
    countryGeoNameId: userData.languageRegion.country && userData.languageRegion.country.geonameId,
    language: userData.languageRegion.language,
    timeZone: userData.languageRegion.timeZone,
    surname: userData.profileInfo.lastName,
    givenName: userData.profileInfo.firstName,
    userAddresses: addressList,
    userPhones: phoneList
  };
  return data;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var isObjectValueEqual = function isObjectValueEqual(obj1, obj2) {
  var o1 = obj1 instanceof Object;
  var o2 = obj2 instanceof Object;

  if (!o1 || !o2) {
    return obj1 === obj2;
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }

  for (var attr in obj1) {
    var t1 = obj1[attr] instanceof Object;
    var t2 = obj2[attr] instanceof Object;

    if (t1 && t2) {
      if ((attr === 'country' || 'province') && obj1[attr].geonameId !== obj2[attr].geonameId) {
        return false;
      } else if (attr === 'phoneCountryCode' && obj1[attr].GeonameId !== obj2[attr].GeonameId) {
        return false;
      } else if (attr === 'timeZone' && (obj1[attr].Alpha2Code !== obj2[attr].Alpha2Code || obj1[attr].Alpha3Code !== obj2[attr].Alpha3Code || obj1[attr].DstOffset !== obj2[attr].DstOffset)) {
        return false;
      } else if (attr !== 'country' && attr !== 'province' && attr !== 'phoneCountryCode' && attr !== 'timeZone') {
        if (!isObjectValueEqual(obj1[attr], obj2[attr])) {
          return false;
        }
      }
    } else if (obj1[attr] !== obj2[attr]) {
      return false;
    }
  }

  return true;
};